export default __webpack_public_path__ + "static/media/clock.715c897b.png";